import React, { useState } from 'react';

const ReviewsSection: React.FC = () => {
  const [form, setForm] = useState({ Name: '', Review: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitted(false);
    try {
      const res = await fetch('https://sheetdb.io/api/v1/lxtf0zao36df6', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: form })
      });
      if (res.ok) {
        setSubmitted(true);
        setForm({ Name: '', Review: '' });
      } else {
        setError('There was a problem submitting your review. Please try again.');
      }
    } catch (err) {
      setError('There was a problem submitting your review. Please try again.');
    }
  };

  return (
    <section id="reviews" className="py-20 bg-black">
      <div className="container mx-auto px-4 max-w-xl">
        <h2 className="section-title text-center pb-3 mb-12">Reviews</h2>
        {submitted && (
          <div className="text-green-500 text-center mb-6">Thank you for your review!</div>
        )}
        {error && (
          <div className="text-red-500 text-center mb-6">{error}</div>
        )}
        <form onSubmit={handleSubmit} className="bg-black/80 border border-gold/30 rounded p-8 space-y-6">
          <div>
            <label className="block text-white mb-2">Your Name</label>
            <input
              type="text"
              name="Name"
              value={form.Name}
              onChange={handleChange}
              className="w-full bg-black/50 border border-gold/30 rounded px-4 py-2 text-white focus:outline-none focus:border-gold"
              required
            />
          </div>
          <div>
            <label className="block text-white mb-2">Your Review</label>
            <textarea
              name="Review"
              value={form.Review}
              onChange={handleChange}
              rows={4}
              className="w-full bg-black/50 border border-gold/30 rounded px-4 py-2 text-white focus:outline-none focus:border-gold"
              required
            />
          </div>
          <div className="text-center">
            <button type="submit" className="gold-btn">Submit Review</button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ReviewsSection; 